'use client';

import Link from 'next/link';
import Image from 'next/image';
import { useState, useEffect } from 'react';

export default function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#home', label: 'Home', active: true },
    { href: '/home-v2', label: 'Home V2', active: false },
    { href: '#about', label: 'About', active: false },
    { href: '#services', label: 'Services', active: false },
    { href: '#portfolio', label: 'Portfolio', active: false },
    { href: '/blog', label: 'Blog', active: false },
    { href: '#contact', label: 'Contact', active: false },
  ];

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href.startsWith('#')) {
      e.preventDefault();
      setMobileMenuOpen(false);
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`ms-nav${scrolled ? ' scrolled' : ''}`}>
      <div className="ms-nav-inner">
        {/* Logo */}
        <Link href="/" className="ms-logo">
          <Image src="/images/logo.svg" alt="MediaSplash" width={180} height={44} priority />
        </Link>

        {/* Desktop Navigation */}
        <div className="ms-nav-links">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className={link.active ? 'active' : ''}
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* Send a Message Button */}
        <a
          href="#contact"
          onClick={(e) => handleNavClick(e, '#contact')}
          className="ms-nav-cta"
        >
          Send a Message
        </a>

        {/* Mobile menu button */}
        <button
          className="ms-mobile-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d={mobileMenuOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'}
            />
          </svg>
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="ms-mobile-menu">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className={link.active ? 'active' : ''}
            >
              {link.label}
            </a>
          ))}
          <div className="ms-mobile-cta-wrap">
            <a
              href="#contact"
              onClick={(e) => handleNavClick(e, '#contact')}
              className="ms-nav-cta"
            >
              Send a Message
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
